import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { CstmPagination } from "../../../components/Common/Common";
import {
  BLOCK_DRIVER,
  DELETE_DRIVER,
  GET_DRIVERS,
} from "../../../services/ApiCalls";
import { toast } from "react-toastify";
import CustomPagination from "../../../components/Common/CustomPagination";
import Table from "../../../components/Common/Table";
import moment from "moment";
import StatusFilter from "../../../components/Common/StatusFilter";
import { csvImportEnum, statusFilterOptionArr } from "../../../utilities/const";
import PaginationFilter from "../../../components/Common/PaginationFilter";
import ConfirmModel from "../../../components/Modals/ConfirmModel";
import ImportCsv from "../../../components/Common/ImportCsv";
import { exportCsvHandler } from "../../../utilities/utilities";
import Search from "../../../components/Common/Search";
import TableProfile from "../../../components/Common/TableProfile";

const ManageDriver = () => {
  const [drivers, setDrivers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [deleteModelStatus, setDeleteModelStatus] = useState(false);
  const [dumpId, setDumpId] = useState("");

  const [body, setBody] = useState({
    page: 1,
    limit: 10,
    orderBy: "createdAt",
    order: -1,
    search: "",
    status: "all",
  });

  const getDrivers = async (body) => {
    setLoader(true);
    try {
      const res = await GET_DRIVERS(body);

      if (res?.data?.status === "success") {
        setDrivers(res?.data?.data);
        setTotalCount(res?.data?.totalcount);
        setLoader(false);
      } else {
        toast.error(res?.data?.message);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);

      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    if (!body.search.trim()) getDrivers(body);
  }, [body.search]);

  const pageChangeHandler = (page) => {
    const newBody = {
      ...body,
      page,
    };
    setBody(newBody);
    getDrivers(newBody);
  };

  const deleteHandler = async () => {
    try {
      const res = await DELETE_DRIVER({ driverId: dumpId });

      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        setDeleteModelStatus(false);
        getDrivers();
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    const newbody = {
      ...body,
      page: 1,
    };
    setBody(newbody);
    getDrivers(newbody);
  }, [body.limit, body.status]);

  const reFetch = () => {
    const newbody = {
      ...body,
      page: 1,
    };
    setBody(newbody);
    getDrivers(newbody);
  };

  const blockAndUnBlockHandler = async (status, providerId, ind) => {
    const oldDrivers = [...drivers];

    const newDrivers = JSON.parse(JSON.stringify(drivers));

    newDrivers[ind].Status = status ? "active" : "inactive";

    setDrivers(newDrivers);

    try {
      const res = await BLOCK_DRIVER({
        providerId,
        status: status ? "active" : "inactive",
      });

      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        // getDrivers(body);
      } else {
        setDrivers(oldDrivers);
        toast.error(res?.data?.message);
      }
    } catch (error) {
     
      setDrivers(oldDrivers);
      toast.error("something went wrong ");
    }
  };

  const searchHandler = async () => {
    const newBody = {
      ...body,
      page: 1,
    };
    setBody(newBody);
    getDrivers(newBody);
  };

  const col = [
    {
      label: "Sr no",
      id: "srNo",
      isComponent: true,
      component: (_, key) => (
        <p className={` m-0`}>{(body.page - 1) * body.limit + (key + 1)}</p>
      ),
    },

    {
      label: "Driver Name",
      isComponent: true,
      id: "name",
      component: (item, key) => (
        // <TableProfile url={item.customerImage} name={item.customerName} />
        <TableProfile
          url={item.profileImage}
          name={item?.name}
        />
      ),
    },


    {
      label: "Email Id",
      id: "email",
    },
    {
      label: "Phone  Number",
      id: "",
      isComponent: true,
      component: (item) => (
        <p className="fw-sbold m-0">{item.countryCode + item.mobileNumber}</p>
      ),
    },
    {
      label: "Created At",
      isComponent: true,
      component: (item) => (
        <p className={` fw-sbold m-0`}>
          {moment(item.createdAt).format("MM/DD/YYYY")}
        </p>
      ),
    },
    // {
    //   label: "Status",
    //   isComponent: true,
    //   component: (item) => (
    //     <p
    //       className={`${
    //         item.Status == "approved" && "greenStatus"
    //       } m-0 fw-sbold status rounded-pill`}
    //     >
    //       <span className="icn me-1">
    //         <svg
    //           xmlns="http://www.w3.org/2000/svg"
    //           width="6"
    //           height="6"
    //           viewBox="0 0 6 6"
    //           fill="none"
    //         >
    //           <circle opacity="0.5" cx="3" cy="3" r="3" fill="currentColor" />
    //         </svg>
    //       </span>{" "}
    //       {item.Status}
    //     </p>
    //   ),
    // },
    {
      label: "Block/UnBlock",
      isComponent: true,
      component: (item, key) => (
        <div className="d-flex align-items-center justify-content-center">
          <Form.Check // prettier-ignore
            type="switch"
            id="custom-switch"
            label=""
            checked={item.Status === "active"}
            onChange={(e) =>
              blockAndUnBlockHandler(e.target.checked, item._id, key)
            }
          />
        </div>
      ),
    },
    {
      label: "Action",
      isComponent: true,
      component: (item) => (
        <div className="actnBtn d-flex align-items-start justify-content-start gap-10">
          {/* <Link
            to={`/manage-driver/edit/${item._id}`}
            className="border-0 p-0"
            variant="transparent"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            >
              <g clip-path="url(#clip0_0_1756)">
                <path
                  d="M3.24006 15.156C3.42006 15.156 3.45606 15.138 3.61806 15.102L6.85806 14.454C7.20006 14.364 7.54206 14.202 7.81206 13.932L15.6601 6.084C16.8661 4.878 16.8661 2.808 15.6601 1.602L14.9941 0.899999C13.7881 -0.306001 11.7001 -0.306001 10.4941 0.899999L2.64606 8.766C2.39406 9.018 2.21406 9.378 2.12406 9.72L1.44006 12.996C1.35006 13.608 1.53006 14.202 1.96206 14.634C2.30406 14.976 2.80806 15.156 3.24006 15.156ZM3.85206 10.062L11.7001 2.196C12.2221 1.674 13.1761 1.674 13.6801 2.196L14.3641 2.88C14.9761 3.492 14.9761 4.356 14.3641 4.95L6.53406 12.816L3.20406 13.374L3.85206 10.062ZM15.5881 16.272H2.30406C1.78206 16.272 1.44006 16.614 1.44006 17.136C1.44006 17.658 1.87206 18 2.30406 18H15.5161C16.0381 18 16.4701 17.658 16.4701 17.136C16.4521 16.614 16.0201 16.272 15.5881 16.272Z"
                  fill="#27AE60"
                  stroke="#F8FAFC"
                  stroke-width="0.3"
                />
              </g>
              <defs>
                <clipPath id="clip0_0_1756">
                  <rect width="18" height="18" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </Link> */}
          <Button
            className="border-0 p-0"
            variant="transparent"
            type="button"
            onClick={() => {
              setDeleteModelStatus(true);
              setDumpId(item._id);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="18"
              viewBox="0 0 16 18"
              fill="none"
            >
              <g clip-path="url(#clip0_0_1726)">
                <path
                  d="M10.1875 13.8438C10.3533 13.8438 10.5122 13.7779 10.6294 13.6607C10.7467 13.5435 10.8125 13.3845 10.8125 13.2188V6.96875C10.8125 6.80299 10.7467 6.64402 10.6294 6.52681C10.5122 6.4096 10.3533 6.34375 10.1875 6.34375C10.0217 6.34375 9.86277 6.4096 9.74556 6.52681C9.62835 6.64402 9.5625 6.80299 9.5625 6.96875V13.2188C9.5625 13.3845 9.62835 13.5435 9.74556 13.6607C9.86277 13.7779 10.0217 13.8438 10.1875 13.8438ZM5.8125 13.8438C5.97826 13.8438 6.13723 13.7779 6.25444 13.6607C6.37165 13.5435 6.4375 13.3845 6.4375 13.2188V6.96875C6.4375 6.80299 6.37165 6.64402 6.25444 6.52681C6.13723 6.4096 5.97826 6.34375 5.8125 6.34375C5.64674 6.34375 5.48777 6.4096 5.37056 6.52681C5.25335 6.64402 5.1875 6.80299 5.1875 6.96875V13.2188C5.1875 13.3845 5.25335 13.5435 5.37056 13.6607C5.48777 13.7779 5.64674 13.8438 5.8125 13.8438ZM10.5 1.65625C10.6658 1.65625 10.8247 1.5904 10.9419 1.47319C11.0592 1.35598 11.125 1.19701 11.125 1.03125C11.125 0.86549 11.0592 0.706518 10.9419 0.589308C10.8247 0.472098 10.6658 0.40625 10.5 0.40625H5.5C5.33424 0.40625 5.17527 0.472098 5.05806 0.589308C4.94085 0.706518 4.875 0.86549 4.875 1.03125C4.875 1.19701 4.94085 1.35598 5.05806 1.47319C5.17527 1.5904 5.33424 1.65625 5.5 1.65625H10.5Z"
                  fill="#EB5757"
                />
                <path
                  d="M1.125 2.28125C0.95924 2.28125 0.800269 2.3471 0.683058 2.46431C0.565848 2.58152 0.5 2.74049 0.5 2.90625C0.5 3.07201 0.565848 3.23098 0.683058 3.34819C0.800269 3.4654 0.95924 3.53125 1.125 3.53125H1.75V15.0312C1.75 16.4437 2.9 17.5938 4.3125 17.5938H11.6875C13.1 17.5938 14.25 16.4437 14.25 15.0312V3.53125H14.875C15.0408 3.53125 15.1997 3.4654 15.3169 3.34819C15.4342 3.23098 15.5 3.07201 15.5 2.90625C15.5 2.74049 15.4342 2.58152 15.3169 2.46431C15.1997 2.3471 15.0408 2.28125 14.875 2.28125H2.375H1.125ZM13 3.53125V15.0312C13 15.3793 12.8617 15.7132 12.6156 15.9593C12.3694 16.2055 12.0356 16.3438 11.6875 16.3438H4.3125C3.9644 16.3438 3.63056 16.2055 3.38442 15.9593C3.13828 15.7132 3 15.3793 3 15.0312V3.53125H13Z"
                  fill="#EB5757"
                />
              </g>
              <defs>
                <clipPath id="clip0_0_1726">
                  <rect width="16" height="18" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </Button>
          <Link
            to={`/manage-driver/detail/${item._id}`}
            className="border-0 p-0"
            variant="transparent"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="13"
              viewBox="0 0 20 13"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.99942 0C5.87279 0 2.68732 2.92137 1.14138 4.63152C0.487156 5.35521 0.112249 5.89152 0.112249 5.89152C-0.0374163 6.10585 -0.0374163 6.39244 0.112249 6.60677C0.112249 6.60677 0.40728 7.02947 0.92408 7.62251C2.37509 9.28752 5.66888 12.4983 9.99942 12.4983C14.4446 12.4983 17.8017 9.1185 19.1907 7.49319C19.6367 6.9711 19.8878 6.60677 19.8878 6.60677C20.0374 6.39244 20.0374 6.10585 19.8878 5.89152C19.8878 5.89152 19.6124 5.49478 19.126 4.93184C17.7002 3.28222 14.3781 0 9.99942 0ZM9.99942 1.25008C13.7359 1.25008 16.8553 4.21593 18.1799 5.74864C18.445 6.05541 18.47 6.10436 18.5814 6.25155C18.4776 6.38815 18.4655 6.41709 18.2396 6.68136C16.9507 8.18975 13.7927 11.2482 9.99942 11.2482C6.30393 11.2482 3.21437 8.34884 1.86524 6.80092C1.5755 6.46852 1.54441 6.40683 1.42699 6.25155C1.56293 6.07013 1.64892 5.93485 2.06799 5.47147C3.50792 3.8784 6.4779 1.25008 9.99942 1.25008ZM9.99942 2.50016C7.93553 2.50016 6.25283 4.18286 6.25283 6.24675C6.25283 8.31048 7.93553 9.99814 9.99942 9.99814C12.0631 9.99814 13.7508 8.31048 13.7508 6.24675C13.7508 4.18286 12.0631 2.50016 9.99942 2.50016ZM9.99942 3.75139C11.3878 3.75139 12.5007 4.85825 12.5007 6.24675C12.5007 7.63508 11.3878 8.74806 9.99942 8.74806C8.61092 8.74806 7.50406 7.63508 7.50406 6.24675C7.50406 4.85825 8.61092 3.75139 9.99942 3.75139Z"
                fill="#645C5C"
              />
            </svg>
          </Link>
        </div>
      ),
    },
  ];

  return (
    <>
      <ConfirmModel
        confirmHandler={deleteHandler}
        modelStatus={deleteModelStatus}
        setModel={setDeleteModelStatus}
        type={"delete"}
      />
      <section className="manageDriver py-2 position-relative">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="sectionHeader">
                <h3 className="m-0 fw-sbold themeBlue">Driver List</h3>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between gap-10 mb-3 mt-3">
                <div className="left">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                    <StatusFilter
                      body={body}
                      setBody={setBody}
                      statusFilterOptionArr={statusFilterOptionArr}
                    />
                    <PaginationFilter body={body} setBody={setBody} />
                    <Search searchHandler={searchHandler} setBody={setBody} />
                  </ul>
                </div>
                <div className="right d-flex align-items-center gap-10">
                  {/* <Button className="d-flex align-items-center justify-content-center commonBtn GreyBtn">
                    Import Csv
                  </Button> */}
                  {/* <ImportCsv item={csvImportEnum.drivers} callBack={reFetch} /> */}
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                    type="button"
                    onClick={() => exportCsvHandler("drivers")}
                  >
                    Export Csv
                  </Button>
                  <Link
                    to="/manage-driver/add"
                    className="d-flex btn btn-primary align-items-center justify-content-center commonBtn"
                  >
                    Add Driver
                  </Link>
                </div>
              </div>
              <div className="table-responsive">
                <Table data={drivers} loader={loader} column={col} />

                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <div className="left">
                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                      <li>
                        <p className="m-0 fw-sbold themeBlue">
                          Total drivers: {totalCount}
                        </p>
                      </li>
                      {/* <li>
                        <p className="m-0 fw-sbold themeBlue">
                          Active drivers: 9
                        </p>
                      </li> */}
                    </ul>
                  </div>
                  <div className="right">
                    <CustomPagination
                      total={totalCount}
                      current={body.page}
                      pageSize={body.limit}
                      pageChangeHandler={pageChangeHandler}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageDriver;
